export const ISOLVED_NETWORK_PROVIDER_IDS = [
  'aap_isolved',
  'ahola',
  'amcheck',
  'aspenhr',
  'coastal_payroll',
  'common_sense_payroll',
  'dominion_payroll',
  'employdrive',
  'hr_butler',
  'ibusiness_solutions',
  'integrated_payroll_services',
  'isolved',
  'kabel',
  'lift_hcm',
  'payfluence',
  'payroll_network',
  'payroll_specialties',
  'payroll_vault',
  'qforce',
  'thread_hcm',
];

export const isIsolvedNetworkProvider = (payrollProviderId: string) => {
  const isNetworkProvider =
    ISOLVED_NETWORK_PROVIDER_IDS.includes(payrollProviderId);
  return isNetworkProvider;
};
